/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancellationTermDto } from './cancellation-term-dto';
import {
    CancellationTermDtoFromJSON,
    CancellationTermDtoFromJSONTyped,
    CancellationTermDtoToJSON,
    CancellationTermDtoToJSONTyped,
} from './cancellation-term-dto';

/**
 * Правило отмены
 * @export
 * @interface CancellationRuleDto
 */
export interface CancellationRuleDto {
    /**
     * Идентификатор правила отмены
     * @type {string}
     * @memberof CancellationRuleDto
     */
    id: string;
    /**
     * Идентификатор объекта размещения
     * @type {string}
     * @memberof CancellationRuleDto
     */
    propertyId?: string;
    /**
     * 
     * @type {Array<CancellationTermDto>}
     * @memberof CancellationRuleDto
     */
    cancellationTerms: Array<CancellationTermDto>;
}

/**
 * Check if a given object implements the CancellationRuleDto interface.
 */
export function instanceOfCancellationRuleDto(value: object): value is CancellationRuleDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('cancellationTerms' in value) || value['cancellationTerms'] === undefined) return false;
    return true;
}

export function CancellationRuleDtoFromJSON(json: any): CancellationRuleDto {
    return CancellationRuleDtoFromJSONTyped(json, false);
}

export function CancellationRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'cancellationTerms': ((json['cancellationTerms'] as Array<any>).map(CancellationTermDtoFromJSON)),
    };
}

  export function CancellationRuleDtoToJSON(json: any): CancellationRuleDto {
      return CancellationRuleDtoToJSONTyped(json, false);
  }

  export function CancellationRuleDtoToJSONTyped(value?: CancellationRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'propertyId': value['propertyId'],
        'cancellationTerms': ((value['cancellationTerms'] as Array<any>).map(CancellationTermDtoToJSON)),
    };
}

